import type { LucideIcon } from "lucide-react";

/**
 * The heading block every page starts with.
 *
 * One component so the title size and description colour stay identical
 * everywhere. Viewing scope lives in the sidebar; page-specific controls go
 * in `actions`.
 */
export function PageHeader({
  title,
  description,
  icon: Icon,
  actions,
  className,
}: {
  title: string;
  description?: React.ReactNode;
  icon?: LucideIcon;
  /** Page-specific buttons, shown to the right of the title. */
  actions?: React.ReactNode;
  className?: string;
}) {
  return (
    <header
      className={
        "flex flex-wrap items-start justify-between gap-x-6 gap-y-3" +
        (className ? ` ${className}` : "")
      }
    >
      <div className="min-w-0">
        <h1 className="flex items-center gap-2 text-2xl font-bold tracking-tight text-white">
          {Icon && <Icon size={22} className="shrink-0 text-bf-muted" aria-hidden />}
          {title}
        </h1>
        {description && (
          <p className="mt-1 max-w-3xl text-sm text-bf-muted">{description}</p>
        )}
      </div>
      {actions && (
        <div className="flex flex-wrap items-center gap-3">{actions}</div>
      )}
    </header>
  );
}
